export default __webpack_public_path__ + "static/media/ic_tracking_rechazo.9c88e36a.svg";